import { getClassName } from "@pairtreefamily/utils";

export type HomeStudyVerifiedProps = {
  className?: string;
  approvedText?: string;
  altText?: string;
};

export function HomeStudyVerified(props: HomeStudyVerifiedProps) {
  const className = getClassName(props.className);

  return (
    <>
      <img
        className={className}
        src="/home_study_badge.svg"
        alt={props.altText}
      />
      {props.approvedText && <span className="text-black">Approved</span>}
    </>
  );
}

export default HomeStudyVerified;
